import { Outlet } from 'react-router-dom';

import { AppHeader } from '@src/design-system/molecules/app-header';
import { AppSidebar } from '@src/design-system/molecules/app-sidebar';
import { SidebarInset, SidebarProvider } from '@src/design-system/sidebar';
import { UserHeaderMetadata } from '@src/shared/components/common/user-header-metadata';

export function NewMainLayout() {
  return (
    <SidebarProvider>
      <UserHeaderMetadata />
      <AppSidebar />
      <SidebarInset>
        <AppHeader />
        <div className='h-full scale-100 overflow-hidden overflow-y-auto'>
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
